<template>
  <div v-if="visible === true" class="object-obstruction-block">
    <div>
      <div>
        <form>
          <div class="field">
            <label for="input-period">
              {{ $t('route_management.obstruction_period_placeholder') }}:
            </label>
            <div id="input-period" class="input-select-field">
              <select
                style="width: 100%"
                v-model="data.period_id"
              >
                <option v-for="obstructionType in obstructionTypes"
                        :value="obstructionType.key" :key="obstructionType.key">
                  {{ $t(`obstruction_type.${obstructionType.type}`) }}
                </option>
              </select>
            </div>
          </div>
          <div v-if="data.period_id !== null" class="field">
            <label for="input-from-date">
              {{ $t('obstruction.from_date') | capitalize }}:
            </label>
            <div id="input-from-date" class="input-date-field">
              <input
                type="date"
                style="width: 50%"
                :class="{'active': true}"
                v-model="data.from_date"
              />
            </div>
          </div>
          <div v-if="data.period_id === 1 || data.period_id === 3" class="field">
            <label for="input-to-date">
              {{ $t('obstruction.to_date') | capitalize }}:
            </label>
            <div id="input-to-date" class="input-date-field">
              <input
                type="date"
                style="width: 50%"
                v-model="data.to_date"
              />
            </div>
          </div>
          <div class="field">
            <label for="input-reason">
              {{ $t('obstruction.reason') | capitalize }}:
            </label>
            <div id="input-reason" class="input-textarea-field">
              <textarea
                type="text"
                :placeholder="$t('route_management.obstruction_reason_placeholder')"
                v-model="data.reason"
              />
            </div>
          </div>
          <div class="field">
            <label for="input-detour">
              {{ $t('obstruction.detour') | capitalize }}:
            </label>
            <div id="input-detour" class="input-textarea-field">
              <textarea
                type="text"
                :placeholder="$t('route_management.obstruction_detour_placeholder')"
                v-model="data.detour"
              />
            </div>
          </div>
          <a @click="closeForm" class="btn grey">
            {{ $t('button.cancel') | capitalize }}
          </a>
          <a
            @click="updateObstruction"
            :class="[
            'btn',
            'module-color-background',
            {'disabled': (data.period_id === 2) ? (data.from_date === null) :
            (data.from_date === null || data.to_date === null)
            }]"
            :disabled="(data.period_id === 2) ? (data.from_date === null) :
            (data.from_date === null || data.to_date === null)"
          >
            {{ $t('button.save') | capitalize }}
          </a>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment/moment';
import ObstructionTypes from '@/enums/ObstructionTypes';

export default {
  moment,
  name: 'ObjectObstructionEdit',
  components: {
  },
  props: {
    id: {
      type: Number,
      required: false,
    },
    obstruction: {
      type: Object,
      required: true,
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      data: {
        map_object_id: null,
        period_id: null,
        from_date: null,
        to_date: null,
        reason: null,
        detour: null,
      },
      obstructionTypes: ObstructionTypes,
    };
  },
  methods: {
    closeForm() {
      this.$emit('showObjectObstructionsForm', 'edit', false);
    },
    updateObstruction() {
      const newData = this.data;
      newData.from_date = moment(newData.from_date).format('YYYY-MM-DD');
      if (newData.period_id === 1 || newData.period_id === 3) {
        newData.to_date = moment(newData.to_date).format('YYYY-MM-DD');
      } else {
        newData.to_date = null;
      }

      this.$emit('showObjectObstructionsForm', 'edit', false);
      this.$emit('updateObstruction', JSON.parse(JSON.stringify(newData)));
    },
  },
  watch: {
    obstruction() {
      this.data = JSON.parse(JSON.stringify(this.obstruction));
      this.data.from_date = moment(this.data.from_date).format('YYYY-MM-DD');
      this.data.to_date = moment(this.data.to_date).format('YYYY-MM-DD');
    },
    id() {
      this.data = JSON.parse(JSON.stringify(this.obstruction));
      this.data.from_date = moment(this.data.from_date).format('YYYY-MM-DD');
      this.data.to_date = moment(this.data.to_date).format('YYYY-MM-DD');
    },
  },
};
</script>

<style scoped>
  .object-obstruction-block {
    padding: 0 20px;
  }
</style>
